import { Component, Input, OnInit, inject } from '@angular/core';
import { UserRoleName } from 'app/core/enums/user-role-name.enum';
import { AuthenticationService } from 'app/core/services/authentication.service';
import { ConsultNoteQueueService } from 'app/core/services/consult-note-queue.service';
import { NavigationService } from 'app/core/services/navigation.service';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { ConsultNoteAssignUserSelectComponent } from '../../../shared/components/consult-note-assign-user-select/consult-note-assign-user-select.component';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-consult-note-assigned-to',
    templateUrl: './consult-note-assigned-to.component.html',
    styleUrls: ['./consult-note-assigned-to.component.scss'],
    imports: [FaIconComponent, FormsModule, ConsultNoteAssignUserSelectComponent, BlankValueDashPipe]
})
export class ConsultNoteAssignedToComponent implements OnInit {
  private authService = inject(AuthenticationService);
  private consultNoteQueueService = inject(ConsultNoteQueueService);
  private navigationService = inject(NavigationService);

  @Input() patientAttachment: PatientAttachment;

  selectedUser: number;
  originalSelectedUser: number;
  canEdit = false;
  editing = false;

  ngOnInit() {
    this.canEdit = this.authService.hasPermissionTo(UserRoleName.consultNoteUser);
    this.originalSelectedUser = this.patientAttachment.assignedTo ?
                                  this.patientAttachment.assignedTo.id :
                                  this.authService.currentUser.id;
  }

  public get assignedToName(): string {
    if (this.patientAttachment.assignedTo) {
      return this.patientAttachment.assignedTo.fullName;
    }
  }

  public handleEdit($event) {
    $event.preventDefault();
    this.editing = true;
  }

  public handleSave($event) {
    $event.preventDefault();

    if (!this.patientAttachment.assignedTo || this.selectedUser !== this.originalSelectedUser) {
      const consultNoteIds = this.consultNoteAndRelatedConsultNoteIds();
      this.consultNoteQueueService.assignUser(this.selectedUser, consultNoteIds).subscribe((result) => {
        if (result.status === 'ok') {
          this.navigationService.reloadCurrentUrl();
        }
      });
    } else {
      this.editing = false;
    }
  }

  public handleCancel($event) {
    $event.preventDefault();
    this.editing = false;
    this.selectedUser = this.originalSelectedUser;
  }

  public handleAssignedUserChanged(id) {
    this.selectedUser = id;
  }

  private consultNoteAndRelatedConsultNoteIds(): number[] {
    const ids = [this.patientAttachment.id];
    if (this.patientAttachment.relatedPatientAttachments) {
      this.patientAttachment.relatedPatientAttachments.forEach((related) => {
        ids.push(related.id);
      });
    }
    return ids;
  }
}
